module.exports = __webpack_public_path__ + "img/partners-FT.b078d207.png";